import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CusSatCommunicationService {
  private openFeedbackSubject = new Subject<void>();
  public openFeedback$ = this.openFeedbackSubject.asObservable();

  openFeedback(): void {
    this.openFeedbackSubject.next();
  }
}

